import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import MEliminarMaestro from "@ProductosProduccion/ModalesDetalleInferior/MEliminarMaestro";
import MAgregarEditarMaestro from "@ProductosProduccion/ModalesDetalleInferior/MAgregarEditarMaestro";

import MEliminarPT from "@ProductosProduccion/ModalesDetalleInferior/MEliminarPT";
import MAgregarEditarPT from "@ProductosProduccion/ModalesDetalleInferior/MAgregarEditarPT";

import * as _testing_ from "@Funciones/testing";
import "./MDetalleInferiorProductoProduccion.css";

function MDetalleInferiorProductoProduccion({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],

    //ADICIONALES
    relacionarMaestro_mostrar: false,
    relacionarPT_mostrar: false,
  });
  const [v_u, ev_u] = useState({
    procesandoAPI: false,
    exitoAPI: false,
    do_datosTabla: {},
    da_gridMaestro: [],
    da_headgridMaestro: [],
    da_gridProductoTerminado: [],
    da_headgridProductoTerminado: [],
  });

  const [recargaMaestros, erecargaMaestros] = useState(false);
  const [recargaPP, erecargaPP] = useState(false);

  useEffect(() => {
    // fCerrarComponentePadre?.();
    console.log("entre a llamar maestros");
    console.log(origenComponente, registro, parametros, tipoEvento);

    const maestroProductoAPI = _api_.f_estructuraObtenerMaestroPP({
      parametros: { codProducto: registro?.codigo },
      timeout: 5000,
    });
    maestroProductoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_gridMaestro: dPC.contenido.grid,
          da_headgridMaestro: dPC.contenido.headgrid,
        });
      }
    });
  }, [recargaMaestros]);

  useEffect(() => {
    const productoTerminadoAPI = _api_.f_estructuraObtenerProductosTerminadosPP({
      parametros: { codProducto: registro?.codigo },
      timeout: 5000,
    });
    productoTerminadoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_gridProductoTerminado: dPC.contenido.grid,
          da_headgridProductoTerminado: dPC.contenido.headgrid,
        });
      }
    });
  }, [recargaPP]);

  return (
    <div className={"MDetalleInferiorProductoProduccionCSS-contenido"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false, relacionarMaestro_mostrar: false, relacionarPT_mostrar: false });
          }}>
          {v_c.relacionarMaestro_mostrar && (
            <MAgregarEditarMaestro
              origenComponente
              datosComplementarios={registro}
              registro={{
                codigoMaestro: "",
                codigoPP: "",
              }}
              fCerrarComponente={() => {
                _f_.asignar(ev_c, { modal_mostrar: false, relacionarMaestro_mostrar: false });
              }}
              fActualizarTablaTotal={(actualizar) => {
                if (actualizar) {
                  erecargaMaestros((prev) => !prev);
                }
              }}
            />
          )}
          {v_c.relacionarPT_mostrar && (
            <MAgregarEditarPT
              origenComponente
              datosComplementarios={registro}
              registro={{
                codigoPT: "",
                codigoPP: "",
              }}
              fCerrarComponente={() => {
                _f_.asignar(ev_c, { modal_mostrar: false, relacionarPT_mostrar: false });
              }}
              fActualizarTablaTotal={(actualizar) => {
                if (actualizar) {
                  erecargaPP((prev) => !prev);
                }
              }}
            />
          )}
        </ModalInformacion>
      )}
      <div className={"MDetalleInferiorProductoProduccionCSS-opciones"}>
        <_btn_.Boton
          texto={`Relacionar Maestro`}
          tipo="btn-2"
          estilos={{
            anchoB2: "7rem",
            altoB2: "50%",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Agregar Relación de Maestro",
              relacionarMaestro_mostrar: true,
              modal_estilos: { anchoMI: "30rem" },
            });
          }}
        />
        <_btn_.Boton
          texto={`Relacionar Producto`}
          tipo="btn-2"
          estilos={{
            anchoB2: "7rem",
            altoB2: "50%",
            color: "#ECAB00",
            colorFuenteB2: "black",
            fuente: "1rem",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Agregar Relación de Producto Terminado",
              relacionarPT_mostrar: true,
              modal_estilos: { anchoMI: "30rem" },
            });
          }}
        />
      </div>
      <div className={"MDetalleInferiorProductoProduccionCSS-tablas"}>
        <div className="MDetalleInferiorProductoProduccionCSS-TablaMaestros">
          <_tabla_.Tabla
            origenComponente={origenComponente}
            modoVista={"modo1"}
            colorCabeceraCategoria={"var(--color_verde_1)"}
            cabecera={v_u.da_headgridMaestro}
            registros={v_u.da_gridMaestro}
            zIndexTabla="2"
            datosComplementarios={registro}
            mapaDeComponentes={{
              MEliminarMaestro,
              MAgregarEditarMaestro,
            }}
            fNotificarActualizacionDeTabla={(actualizar) => {
              if (actualizar) {
                erecargaMaestros((prev) => !prev);
              }
            }}
          />
        </div>
        <div className="MDetalleInferiorProductoProduccionCSS-TablaProductoTerminado">
          <_tabla_.Tabla
            origenComponente={origenComponente}
            modoVista={"modo1"}
            colorCabeceraCategoria={"#ECAB00"}
            cabecera={v_u.da_headgridProductoTerminado}
            registros={v_u.da_gridProductoTerminado}
            zIndexTabla="2"
            datosComplementarios={registro}
            mapaDeComponentes={{
              MEliminarPT,
              MAgregarEditarPT,
            }}
            fNotificarActualizacionDeTabla={(actualizar) => {
              if (actualizar) {
                erecargaPP((prev) => !prev);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
export default MDetalleInferiorProductoProduccion;
